import React from "react";

interface NotFoundPageProps {}

const NotFoundPage: React.FC<NotFoundPageProps> = () => {
  return <div>not found</div>;
};

export default NotFoundPage;
